;
( function( $, window, document, undefined )
{
    'use strict';

    var EditorPDC = function( el, options )
    {
        this.$doc    = $( document );
        this.$body   = $( 'body' );
        this.$editor = el.closest( '.reply-editor' );
        this.$el     = el;
        this.attrId  = this.$el.attr( 'id' );
        this.init();
    };

    EditorPDC.prototype = {

        init : function()
        {
            try {
              this.setup( this.$el.attr( 'id' ) );
            } catch( e ){}

            //this.modals();
            // if (!this.$doc[0].observing) {
            //   this.$doc[0].observing = true;
            //   this.observe();
            // }
        },

        layout : function (id) {
            if (!$('#logged-in-user').data('canHtml')){
                return;
            }

            var $button  = $('<div class="mce-widget mce-btn mce-btn-small mce-last mce-html" aria-label="View HTML"><button role="presentation" type="button" tabindex="-1"></button></div>')
            var $editor  = this.$el.closest('.editor-holder');
            var id       = this.attrId;
            var $toolbar = $editor.find('.mce-last.mce-btn-group');
            var $close = $('<a href="#" class="close-html-view">&times;</a>').appendTo($editor);

            $button.appendTo($toolbar.children());

            $('input[type="submit"].lia-js-hide-keyboard').remove();

            // $('.mce-ico.lia-fa-camera').parent().click(function (e) {
            //     var before = $(window).scrollTop();

            //     setTimeout(function () {
            //         $(window).scrollTop(before);
            //     }, 50);
            // });

            $close.on('click', $.proxy(function (e) {
                e.preventDefault();
                var html = $editor.find('textarea').val();
                $editor.removeClass('editing-html');
                tinymce.editors[id].setContent(html);
            }, this));

            $button.find('button').on('click', $.proxy(function () {
                var html = tinymce.editors[id].save();
                $editor.addClass('editing-html');
                $editor.find('textarea').focus().val(html);
            }, this));
        },

        toggleComposing: function (editor, toggle) {
          //common.els.$body.header('toggleBodyOverflow', toggle);
          //common.els.$body[toggle ? 'addClass' : 'removeClass']('composing-reply');
          //$('#'+editor.id).closest('.reply-editor')[toggle ? 'addClass' : 'removeClass']('composing');
        },

        setup : function( attrId )
        {
            var that = this;
            var id = '#' + attrId;
            var $emailMe = this.$el.closest( '.reply-editor' ).find( '.email-me' );
            $emailMe.find( 'input' ).attr( 'id', 'email-me-' + id );
            $emailMe.find( 'label' ).attr( 'for', 'email-me-' + id );
            var lang = LITHIUM.CommunityJsonObject.User.settings["profile.language"];
            var direction = 'ltr';
            if (lang == 'ar') {
                direction = 'rtl';
            }

            var ed = LITHIUM.TinyMceEditor( id, {
                "spellcheckerUrl":"/spellchecker/lucene",
                "spellcheckerLangs":"English=en-gb,Turkish=tr,Arabic=ar,English=en,Russian=ru,Portuguese=pt,Dutch=nl,Italian=it,French=fr,Finnish=fi,Spanish=es,German=de,Danish=da,Greek=el",
                "useUserMentions":true,
                "toolbarTitle":"",
                "plainTextOnPaste":true,
                "toolbarSelector":".mce-toolbar-grp",
                "useProductMentions":false,
                "iframeTitle":"",
                "useLegacySpellChecker":false,
                "events":{
                    "editorPasteEvent":"LITHIUM:editorPaste",
                    "editorLoadedEvent":"LITHIUM:editorLoaded"
                },
                "useGraphicalEditor":true,
                "imageUrlPattern": "/t5/image/serverpage/image-id/<image-id>/image-size/<image-size>?v=mpbl-1&px=-1"
            },
            {
                "toolbar2" : "",
                "toolbar1" : "emoticons_yoda,embedvideo,image,|,bold,italic,underline,strikethrough,|,bullist,numlist,|,link,spoiler",
                "plugins": [
                    "lists",
                    "compat3x",
                    "image",
                    "link",
                    "textcolor",
                    "table",
                    "code",
                    "tabfocus",
                    "paste",
                    "-spoiler",
                    "-insertcode",
                    "-mentions",
                    "noneditable",
                    "-emoticons_yoda",
                    "-imageuploader",
                    "-video",
                    "media",
                    "-spellchecker"
                ],
                "base_url" : "/html/js/lib/tinymce/4.2.8",
                "body_class" : "lia-message-editor",
                "directionality" : direction,
                "language" : lang,
                "theme" : "modern",
                browser_spellcheck: true,
                setup: function (editor) {
                    editor.on('init', function(args) {
                        that.layout(args.target.id);

                        // var body = editor.getBody();
                        // $(body).on('focus', function () {
                        //     that.toggleComposing(editor, true);
                        // });

                        // $(body).on('blur', function () {
                        // //parent.alert('blur!');
                        //     that.toggleComposing(editor, false);
                        // });
                    });
                },
                "entity_encoding" : "raw",
                "toolbar3" : "",
                "height" : 90,
                //"statusbar": false,
                'theme_modern_toolbar_location' : 'bottom',
                "content_css" : $( 'link[href*="playstation_europe_skin"]' ).attr( 'href' )
            }, [
                "/html/js/lib/tinymce/4.2.8/langs/" + lang + ".js",
                "/html/js/lib/tinymce/4.2.8/themes/modern/theme.js",
                "/html/js/lib/tinymce/4.2.8/plugins/lists/plugin.js",
                "/html/js/lib/tinymce/4.2.8/plugins/compat3x/plugin.js",
                "/html/js/lib/tinymce/4.2.8/plugins/image/plugin.js",
                "/html/js/lib/tinymce/4.2.8/plugins/link/plugin.js",
                "/html/js/lib/tinymce/4.2.8/plugins/textcolor/plugin.js",
                "/html/js/lib/tinymce/4.2.8/plugins/table/plugin.js",
                "/html/js/lib/tinymce/4.2.8/plugins/code/plugin.js",
                "/html/js/lib/tinymce/4.2.8/plugins/tabfocus/plugin.js",
                "/html/js/lib/tinymce/4.2.8/plugins/paste/plugin.js",
                "/plugin/editors/tinymce/plugins/spoiler/plugin.js",
                "/plugin/editors/tinymce/plugins/spoiler/langs/" + lang + ".js",
                "/plugin/editors/tinymce/plugins/insertcode/plugin.js",
                "/plugin/editors/tinymce/plugins/insertcode/langs/" + lang + ".js",
                "/plugin/editors/tinymce/plugins/mentions/plugin.js",
                "/plugin/editors/tinymce/plugins/mentions/langs/" + lang + ".js",
                "/html/js/lib/tinymce/4.2.8/plugins/noneditable/plugin.js",
                //"/plugin/editors/tinymce/plugins/emoticons/plugin.js",
                //"/plugin/editors/tinymce/plugins/emoticons/langs/" + lang + ".js",
                "/plugin/editors/tinymce/plugins/imageuploader/plugin.js",
                "/plugin/editors/tinymce/plugins/imageuploader/langs/" + lang + ".js",
                "/plugin/editors/tinymce/plugins/video/plugin.js",
                "/plugin/editors/tinymce/plugins/video/langs/" + lang + ".js",
                "/html/js/lib/tinymce/4.2.8/plugins/media/plugin.js",
                "/html/js/lib/tinymce/4.2.8/plugins/media/plugin.js",
                "/plugin/editors/tinymce/plugins/spellchecker/plugin.js"
            ], [
                {
                    "sourceUrl": "/plugin/editors/tinymce/plugins/spoiler/plugin.js",
                    "name": "spoiler"
                },
                {
                    "sourceUrl": "/plugin/editors/tinymce/plugins/insertcode/plugin.js",
                    "name": "insertcode"
                },
                {
                    "sourceUrl": "/plugin/editors/tinymce/plugins/mentions/plugin.js",
                    "name": "mentions"
                },
                /*
                {
                "sourceUrl": "/plugin/editors/tinymce/plugins/emoticons/plugin.js",
                "name": "emoticons"
                },
                */
                {
                    "sourceUrl": "/plugin/editors/tinymce/plugins/imageuploader/plugin.js",
                    "name": "imageuploader"
                },
                {
                    "sourceUrl": "/plugin/editors/tinymce/plugins/video/plugin.js",
                    "name": "video"
                },
                {
                    "sourceUrl": "/plugin/editors/tinymce/plugins/spellchecker/plugin.js",
                    "name": "spellchecker"
                }
            ], null, false);
        }

    };

    $.fn.EditorPDC = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'EditorPDC' );

        if( !instance )
        {
            instance = new EditorPDC( this, options );
            $item.data( 'EditorPDC', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );
